import { c as _c } from "react/compiler-runtime";
import { useScribeTime } from "@/stores/scribe-store";
export const Timer = () => {
  const $ = _c(2);
  const {
    recordingSeconds
  } = useScribeTime();
  const formatTime = _temp;
  const t0 = formatTime(recordingSeconds);
  let t1;
  if ($[0] !== t0) {
    t1 = <span className="text-body-strong text-primary">{t0}</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}